import type { ReactElement } from "react";
import { Brand } from "./Brand";
import { NavList } from "./NavList";
import { UserMenu } from "./UserMenu";
import styles from "./SideNav.module.css";

export interface SideNavProps {
  currentPath: string;
  onSignOut: () => void;
  onNavigate?: (href: string) => void;
}

export function SideNav({
  currentPath,
  onSignOut,
  onNavigate,
}: SideNavProps): ReactElement {
  return (
    <aside className={styles.nav}>
      <div className={styles.logoRow}>
        <Brand size={30} />
      </div>
      <NavList currentPath={currentPath} onNavigate={onNavigate} />
      <div className={styles.userRow}>
        <UserMenu
          key={currentPath}
          onSignOut={onSignOut}
          onAccount={() => onNavigate?.("/app/account")}
        />
      </div>
    </aside>
  );
}
